var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_15133_119430)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.842 13.55L15.302 14.102C14.87 14.534 14.6 14.9 14.6 15.8H13.4V15.5C13.4 14.834 13.67 14.234 14.102 13.802L14.846 13.046C15.068 12.83 15.2 12.53 15.2 12.2C15.2 11.534 14.66 11 14 11C13.6817 11 13.3765 11.1264 13.1515 11.3515C12.9264 11.5765 12.8 11.8817 12.8 12.2H11.6C11.6 11.5635 11.8529 10.953 12.3029 10.5029C12.753 10.0529 13.3635 9.8 14 9.8C14.6365 9.8 15.247 10.0529 15.6971 10.5029C16.1471 10.953 16.4 11.5635 16.4 12.2C16.4 12.728 16.184 13.202 15.842 13.55ZM14.6 18.2H13.4V17H14.6M14 8C13.2121 8 12.4319 8.15519 11.7039 8.45672C10.9759 8.75825 10.3145 9.20021 9.75736 9.75736C8.63214 10.8826 8 12.4087 8 14C8 15.5913 8.63214 17.1174 9.75736 18.2426C10.3145 18.7998 10.9759 19.2417 11.7039 19.5433C12.4319 19.8448 13.2121 20 14 20C15.5913 20 17.1174 19.3679 18.2426 18.2426C19.3679 17.1174 20 15.5913 20 14C20 10.682 17.3 8 14 8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15133_119430",
    x1: 34.2332,
    y1: 21.7668,
    x2: 21.7668,
    y2: -6.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD1C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6480C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/FAQ_Icon.3f5eb0fce8fb7af1173a51b6fb141f1d.svg";
export { ForwardRef as ReactComponent };